module.exports = ".myForm{\n    width: 60%;\n}\n\n@media (max-width: 900px) {\n    .myForm{\n        width: 95%;\n    }\n}"